import * as React from 'react';
import { Grid, StyledComponentProps } from '@material-ui/core';
import { SearchBoxApi } from '../../../ui-components/SearchBoxApi/SearchBoxApi';
import { contact } from '../../../model/contact';
import { invokeApi } from '../../../common/networking/invoker';
import DatePicker from '../../../ui-components/DatePicker/DatePicker';

interface IProps extends StyledComponentProps {
    searchByDate: (sub?: string, date?: Date, dateTo?: Date) => void;
}

const templateSearchBoxContact = (contact?: contact) => {
    return contact ? {
        label: (contact.surname ? contact.surname + " " + contact.name + " - " : "") + contact.email,
        value: contact
    } : undefined;
}
const searchContactsSearchBox = (search: string, take?: number): Promise<Array<contact>> => {
    return new Promise((resolve, reject) => {
        invokeApi({
            path: take ? `/api/Contacts?fullnameOrEmail=${search}&take=${take}`
                : `api/Contacts?fullnameOrEmail=${search}&take=3`,
            method: 'GET',
            responseType: "json",
        }).then(val => {
            resolve(val);
        }).catch(val => {
            reject(val)
        })
    })
}


// interface IState {
//     selectedUser: contact;
//     filterDate?: Date
//     filterDateTo?: Date
// }

// export default class Filters extends React.Component<IProps, IState> {
//     constructor(p, c) {
//         super(p, c);
//         this.state = {
//             filterDate: new Date(),
//             filterDateTo: null,
//             selectedUser: null,
//         }
//     }
export const Filters = (props: IProps) => {
    const { searchByDate } = props;
    const [selectedUser, setSelectedUser] = React.useState<contact>(null);
    const [filterDate, setFilterDate] = React.useState<Date>(new Date());
    const [filterDateTo, setFilterDateTo] = React.useState<Date>(null);

    React.useEffect(() => {
        console.info("START SEARCH BY DATE", selectedUser, filterDate, filterDateTo)
        searchByDate(selectedUser?.sub, filterDate, filterDateTo);
        // if (props.trainers && props.trainers.length > 0) {
        //     const t = props.trainers.filter(a => activity.trainerIds.indexOf(a._id) > -1);
        //     setSelectedTrainers(t);
        // }
    }, [selectedUser, filterDate, filterDateTo])

    const setxFilterDate = (d: Date) => {
        // console.log("setFilterDate", d)
        if (isValidDate(d) === true || d === undefined) {
            setFilterDate(d === undefined ? null : d);
            // this.setState({ filterDate: d });
            // this.props.searchByDate(this.state.selectedUser?.sub, d);
        }
    }

    const setxFilterDateTo = (d: Date) => {
        // console.log("setFilterDateTo", d)
        if (isValidDate(d) === true || d === undefined) {
            setFilterDateTo(d === undefined ? null : d);
            // this.setState({ filterDate: d });
            // this.props.searchByDate(this.state.selectedUser?.sub, d);
        }
    }

    const isValidDate = (d: any) => {
        return d instanceof Date && !isNaN(d.getTime());
    }

    // const classes = props.classes;

    // let contact: contact;
    return <>
        <Grid container className={props.classes.root} spacing={2}>
            <Grid item xs={6} sm={6} >
                <SearchBoxApi<contact>
                    selectedItem={selectedUser}
                    openOnFocus
                    doFilter
                    disabled={false}
                    listSize={10}
                    getItems={searchContactsSearchBox}
                    label={"Utente"}
                    placeholder={"Digitare cognome o nome"}
                    templateItem={templateSearchBoxContact}
                    onSelectedChange={(item) => {
                        setSelectedUser(item);
                        // this.setState({ selectedUser: item });
                        // searchByDate(item?.sub, filterDate);
                    }} />
            </Grid>
            <Grid item xs={3} sm={3}>
                <DatePicker
                    key={`filter-accesses-from-date-picker`}
                    label="(da) Data Accesso"
                    fullWidth
                    clearable={true}
                    value={filterDate}
                    onChange={(d) => setxFilterDate(d)}
                />
            </Grid>
            <Grid item xs={3} sm={3}>
                <DatePicker
                    key={`filter-accesses-to-date-picker`}
                    label="a Data Accesso"
                    fullWidth
                    clearable={true}
                    value={filterDateTo}
                    onChange={(d) => setxFilterDateTo(d)}
                />
            </Grid>
        </Grid>
    </>

}